import {SetFieldFn} from "../../data";
import {mandantenStyles} from "../../../styles/mandanten/mandanten.styles";
import {Box} from "@mui/material";
import SearchField from "../../SearchField";
import {useUpdateSearchParam} from "../../../hooks/useUpdateSearchParams";

export type MandantenFilter = {
    search?: string;
    filtered?: string;
}

interface FilterTableMandantenProps {
    search?: string;
    setField: SetFieldFn<MandantenFilter>;
}

export default function FilterTableMandanten({ search, setField }: FilterTableMandantenProps) {
    const updateSearchParam = useUpdateSearchParam();

    const handleSearchChange = (searchString: string) => {
        setField("search", searchString);
        updateSearchParam("search", searchString);
    };

    return (
        <Box sx={mandantenStyles.filterTableMandanten.box}>
            <SearchField
                value={search ?? ""}
                onChange={(searchString: string) => handleSearchChange(searchString)}
            />
        </Box>
    );
}